import { createRouter, createWebHistory } from 'vue-router'
import BatchDetailsPage from '@/pages/BatchDetailsPage.vue'
import BatchesPage from '@/pages/BatchesPage.vue'
import LoginPage from '@/pages/LoginPage.vue'
import RegisterPage from '@/pages/RegisterPage.vue'
import { useAuthStore } from '@/stores/auth'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', redirect: { name: 'login' } },
    {
      path: '/login',
      name: 'login',
      component: LoginPage,
      meta: { layout: 'guest' }
    },
    {
      path: '/register',
      name: 'register',
      component: RegisterPage,
      meta: { layout: 'guest' }
    },
    {
      path: '/batches',
      name: 'batches',
      component: BatchesPage,
      meta: { requiresAuth: true, layout: 'auth' }
    },
    {
      path: '/batches/:id',
      name: 'batch-details',
      component: BatchDetailsPage,
      meta: { requiresAuth: true, layout: 'auth' }
    }
  ]
})

router.beforeEach((to) => {
  const auth = useAuthStore()
  const adminDashboardUrl = import.meta.env.VITE_ADMIN_DASHBOARD_URL?.trim()

  if (to.name === 'login' && to.query.force_logout === '1') {
    auth.logout()
    return { name: 'login', query: {}, replace: true }
  }

  if (auth.isAuthenticated && auth.user?.role === 'admin' && adminDashboardUrl) {
    if (to.name === 'login' || to.name === 'register') {
      const redirectUrl = new URL(adminDashboardUrl)

      if (auth.token) {
        redirectUrl.searchParams.set('token', auth.token)
      }

      redirectUrl.searchParams.set('role', auth.user.role)
      redirectUrl.searchParams.set('email', auth.user.email)
      redirectUrl.searchParams.set('name', auth.user.name)

      window.location.replace(redirectUrl.toString())
      return false
    }
  }

  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    return { name: 'login' }
  }

  if ((to.name === 'login' || to.name === 'register') && auth.isAuthenticated) {
    return { name: 'batches' }
  }

  return true
})

export default router
